

<div class="contents" >
    <form [formGroup]="adrPersonnelForm">
    <div class="adr_personnel">
    <!-- <div class="form_input"> -->
      <div class="top">
        <h2 class="title">ADR Personnel</h2>
      </div>
    <!-- </div> -->
    <div class="toggle_view">
      <mat-button-toggle-group
    name="fontStyle"
    aria-label="Font Style"
    color="accent"
    class="m-3"
    
    >
    <mat-button-toggle value="list" color="accent" (click)="onList()"
      ><mat-icon class="example-tab-icon"
        >list</mat-icon
      ></mat-button-toggle
    >
    <mat-button-toggle value="grid" (click)="onGrid()"
      ><mat-icon class="example-tab-icon"
        >view_module</mat-icon
      ></mat-button-toggle
    >
    </mat-button-toggle-group>
    </div>
    <div class="entry_values" *ngIf="gridView">
      <div class="entry" *ngFor="
      let personnel of selectedSuitProgresss.adrPersonnels;
      index as i
    ">
        <h1 class="section_name">
          <em class="ti-user"></em> 
          <span class="name">{{personnel.PersonnelName}}</span>
          <!-- <em class="ti-trash"></em>  -->
        </h1>

        <div class="other_info">
          <p class="label">Community: <span class="item">{{getCommunity(personnel.CommunityId).CommunityName}}</span></p>
          <p class="label">Address: <span class="item">{{personnel.Address}}</span></p>
          <p class="label">Phone: <span class="item">{{personnel.Phone}}</span></p>
          <p class="label">Role Played:<span class="item">{{personnel.RolePlayed}}</span></p>
        </div>
      </div>
     
    </div>
  </div>
  </form>
</div>

<div class="card" *ngIf="listView">
  <form  [formGroup]="adrPersonnelForm">
    <table class="table table-hover" >
      <thead>
        <tr>
          <th scope="col">S/N</th>
          <th scope="col">Name</th>
          <th scope="col">Community</th>
          <th scope="col">Address</th>
          <th scope="col">Phone</th>
          <th scope="col">Role Played</th>
        </tr>
      </thead>
      <tbody >
        <tr *ngFor="
        let personnel of selectedSuitProgresss.adrPersonnels;
        index as i
      ">
          <th scope="row">{{i + 1}}</th>
          <td>{{personnel.PersonnelName}}</td>
          <td>{{getCommunity(personnel.CommunityId).CommunityName}}</td>
          <td>{{personnel.Address}}</td>
          <td>{{personnel.Phone}}</td>
          <td>{{personnel.RolePlayed}}</td>
        </tr>

      </tbody>
    </table>
  </form>
</div>